import { APP_BASE_HREF } from '@angular/common';
import { ChangeDetectorRef, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ResponseHandler } from '@app/_core/helper/ResponseHandler';
import { Utils } from '@app/_core/helper/Utils';
import { AppService } from '@app/_core/services/app.service';
import { ManagerService } from '@app/_core/services/manager.service';
import { WebStorageService } from '@app/_core/services/webstorage.service';
import { FilteredList } from '@app/_entities/filtered-list';
import { FilterDialogComponent } from '@app/pages/common/filter-dialog/filter-dialog.component';
import { ShowHideDialogComponent } from '@app/pages/common/show-hide-dialog/show-hide-dialog.component';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { TableLazyLoadEvent } from 'primeng/table';
import { catchError, EMPTY, map } from 'rxjs';

import { SecurityService } from './../../../_core/services/security.service';

@Component({
  selector: 'app-voicemails',
  templateUrl: './voicemails.component.html',
  styleUrls: ['./voicemails.component.scss'],
})
export class VoicemailsComponent implements OnInit, OnDestroy{
  constructor(
    private cdr: ChangeDetectorRef,
    private utils: Utils,
    private webStorage: WebStorageService,
    private appService: AppService,
    private managerService: ManagerService,
    private securityService: SecurityService,
    private router: Router,
    private modalService: BsModalService,
    @Inject(APP_BASE_HREF) public baseHref: string
  ) {}

  currentMenu: any = {};
  action = '';
  innerHeight = 10;
  showTable: boolean = true;
  showCrud: boolean = false;

  first = 0;
  totalRecords: number;
  loading: boolean;
  modalRef?: BsModalRef;
  loadVoicemailTimeout: any;

  voiceMailList: any = [];

  localStorageName = 'VoicemailsColumnDisplaySettings';
  headercount: any = { shown: 0, hidden: 0 };

  /*globalfilter*/
  findOptions: any = [
    { label: 'User', value: 'User' },
    { label: 'Company', value: 'Company' },
    { label: 'User Phone', value: 'UserPhoneNumber' },
    { label: 'Inbound Phone', value: 'InboundPhoneNumber' },
    { label: 'Request Type', value: 'RequestType' },
    { label: 'Interaction ID', value: 'InteractionID' },
    { label: 'Voicemail ID', value: 'VoicemailID' },
  ];
  showDateRange: boolean = true;

  rowOffset = 0;
  rowCount = 10;
  searchField: any = { label: '', value: '' };
  searchValue: any = '';
  filterDict: any = [];
  sortColumn = 'ID';
  sortDescend = true;
  filterOptionRequestColumn = null;
  fromDate: Date = new Date();
  toDate: Date = new Date();
  pl: any = {};
  filteredList = new FilteredList();

  cols: any = [
    { name: 'ID', label: 'ID', minWidth: 5 },
    { name: 'Agent', label: 'Agent', showFilter: true, minWidth: 8 },
    { name: 'InteractionID', label: 'Interaction ID', minWidth: 8 },
    { name: 'User', label: 'User', showFilter: true, minWidth: 8 },
    { name: 'Company', label: 'Company', showFilter: true, minWidth: 8 },
    { name: 'UserPhoneNumber', label: 'User Phone', showFilter: true, minWidth: 9 },
    { name: 'InboundPhoneNumber', label: 'Inbound Phone', showFilter: true, minWidth: 9 },
    { name: 'Queue', label: 'Queue', showFilter: true, minWidth: 8 },
    { name: 'RequestType', label: 'Request Type', minWidth: 8 },
    {
      name: 'Duration',
      label: 'Duration',
      type: 'numeric',
      format: 'duration',
      minWidth: 8
    },
    { name: 'Status', label: 'Status', showFilter: true, sortable: false, minWidth: 8 },
    { name: 'Created', label: 'Received', type: 'date', minWidth: 10 },
  ];

  ngOnInit(): void {
   // console.log(this.cols, 'filtered coloum');

    this.fromDate.setFullYear(this.fromDate.getFullYear() - 1);
    this.pl = {
      rowOffset: 0,
      rowCount: 10,
      filterOptionRequestColumn: this.filterOptionRequestColumn,
      searchValue: this.searchValue,
      searchField: this.searchField.value,
      filterDict: this.filterDict,
      sortColumn: this.sortColumn,
      sortDescend: this.sortDescend,
      currentUserOnly: false,
      isExport: false,
      filter: {
        FromDate: new Date(this.fromDate).getTime(),
        ToDate: new Date(this.toDate).getTime(),
      },
    };
    this.appService.currentMenu.subscribe((val: boolean) => {
      this.currentMenu = val;
      this.action = this.currentMenu?.name;
    });
    this.searchField = this.findOptions[0];
    this.initializeColumnHeader();
    //this.loadVoicemail(null);
  }

  formatTime(time: any) {
    return this.utils.formatTime(time);
  }
  
  applySelectedDateRange(val) {
    this.toDate = val.toDate;
    this.fromDate = val.fromDate;
    this.loadVoicemail(null);
  }
  
  resetDateRange() {
    this.toDate = new Date();
    this.fromDate = new Date();
    this.fromDate.setFullYear(this.fromDate.getFullYear() - 1);
    this.loadVoicemail(null);

  }

  initializeColumnHeader() {
    const localCol = this.webStorage.getItemFromLocalStorage(this.localStorageName);
    if (localCol != null) {
      this.cols = localCol;
    } else {
      for (const col of this.cols) {
        if (col.name == this.sortColumn) {
          if (this.sortDescend) {
            col.isAsc = false;
          } else {
            col.isAsc = true;
          }
        } else {
          delete col.isAsc;
        }
        col.hide = false;
      }
      this.webStorage.setItemInLocalStorage(this.localStorageName, this.cols);
    }
    this.getColumnCount();
  }

  getColumnCount() {
    let shown = 0;
    let hidden = 0;
    for (const header of this.cols) {
      if (header.hide) {
        hidden++;
      } else {
        shown++;
      }
    }
    this.headercount.shown = shown;
    this.headercount.hidden = hidden;
  }

  /*globalFilter*/
  clearSearchBox() {
    this.searchValue = '';
    this.pl['searchField'] = { label: '', value: '' };
    this.loadVoicemail(null);
  }

  clearFilter() {
    this.cols.forEach((col: any) => {
      delete col.filterVals;
    });
    this.filterOptionRequestColumn = null;
    // Clear the filterDict as well since all filters are removed
    this.filterDict = [];
    this.loadVoicemail(null);
    //this.voiceMailList = this.applyColumnFilters();
    //this.dataToDisplay = this.applyColumnFilters(this.filteredData);
  }

  applyFilterByField(val: any) {
    this.searchField = val.searchField;
    this.searchValue = val.searchValue;
    this.loadVoicemail(null);
  }

  /*column filter* starts here*/
  toggleCustomColumnFilter(colName: string) {
    // Check if column already has filter values with actual data
    const existingCol = this.cols.find(col => col.name === colName);
    
    if (existingCol && existingCol.filterVals && Array.isArray(existingCol.filterVals) && existingCol.filterVals.length > 0) {
      // Column already has filter values, show the dialog directly
      this.showColumnFilterModal(colName);
    } else {
      // Column doesn't have filter values or filterVals is empty/undefined, fetch them from server
      this.filterOptionRequestColumn = colName;
      this.loadVoicemail(null);
    }
  }

  showColumnFilterModal(colName: string) {
    // let filteredValue = this.getFilteredList(colName)

    this.cdr.detectChanges();
    // Don't call getColDetails here - it would overwrite columns with stale data from filteredList
    // The column already has fresh filterVals from either cache or server response
    // this.getColDetails(this.cols, this.filteredList);

    const initialState = {
      cols: this.cols,
      colName: colName,
      // filteredValue: filteredValue
    };

    const config: ModalOptions = { class: 'task-menu', backdrop: 'static', initialState };
    this.modalRef = this.modalService.show(FilterDialogComponent, config);

    this.modalRef.content.event.subscribe((result: any) => {
      this.cols = result.data;
      this.cdr.detectChanges();
      
      // Find the specific column that was updated
      const updatedColumn = result.data.find(col => col.name === colName);
      if (updatedColumn) {
        this.storeFilteredList(updatedColumn, colName);
      }
      // this.getColDetails(this.cols, this.filteredList)

      this.applyColumnFilters();
    });
  }

  populateFilteredListForColumn(colName: string, filterVals: any[]) {
    switch (colName) {
      case 'Agent':
        this.filteredList.agent = filterVals;
        break;
      case 'User':
        this.filteredList.user = filterVals;
        break;
      case 'Company':
        this.filteredList.company = filterVals;
        break;
      case 'UserPhoneNumber':
        this.filteredList.userPhone = filterVals;
        break;
      case 'InboundPhoneNumber':
        this.filteredList.inboundPhone = filterVals;
        break;
      case 'Queue':
        this.filteredList.queue = filterVals;
        break;
      case 'Status':
        this.filteredList.status = filterVals;
        break;
    }
  }

  storeFilteredList(colData, colName) {
    // If filterVals was deleted (cleared), set the corresponding filteredList property to empty array
    const filterVals = colData.filterVals || [];
    
    switch (colName) {
      case 'Agent':
        this.filteredList.agent = filterVals;
        break;
      case 'User':
        this.filteredList.user = filterVals;
        break;
      case 'Company':
        this.filteredList.company = filterVals;
        break;
      case 'UserPhoneNumber':
        this.filteredList.userPhone = filterVals;
        break;
      case 'InboundPhoneNumber':
        this.filteredList.inboundPhone = filterVals;
        break;
      case 'Queue':
        this.filteredList.queue = filterVals;
        break;
      case 'Status':
        this.filteredList.status = filterVals;
        break;
    }
  }

  getFilteredList(colName) {
    switch (colName) {
      case 'Agent':
        return this.filteredList.agent;
      case 'User':
        return this.filteredList.user;
      case 'Company':
        return this.filteredList.company;
      case 'UserPhoneNumber':
        return this.filteredList.userPhone;
      case 'InboundPhoneNumber':
        return this.filteredList.inboundPhone;
      case 'Queue':
        return this.filteredList.queue;
      case 'Status':
        return this.filteredList.status;
    }
    return null;
  }
  getColDetails(cols, filteredList) {
    if (filteredList) {
      for (const col of cols) {
        // Only update filterVals if the column doesn't already have them
        // This prevents overwriting the current column's fresh data
        if (col.filterVals) {
          // Column already has filterVals, don't overwrite
          continue;
        }
        
        if (col.name == 'Agent') {
          if (filteredList.agent && Array.isArray(filteredList.agent)) {
            col.filterVals = filteredList.agent;
          }
        }
        if (col.name == 'User') {
          if (filteredList.user && Array.isArray(filteredList.user)) {
            col.filterVals = filteredList.user;
          }
        }
        if (col.name == 'Company') {
          if (filteredList.company && Array.isArray(filteredList.company)) {
            col.filterVals = filteredList.company;
          }
        }
        if (col.name == 'UserPhoneNumber') {
          if (filteredList.userPhone && Array.isArray(filteredList.userPhone)) {
            col.filterVals = filteredList.userPhone;
          }
        }
        if (col.name == 'InboundPhoneNumber') {
          if (filteredList.inboundPhone && Array.isArray(filteredList.inboundPhone)) {
            col.filterVals = filteredList.inboundPhone;
          }
        }
        if (col.name == 'Queue') {
          if (filteredList.queue && Array.isArray(filteredList.queue)) {
            col.filterVals = filteredList.queue;
          }
        }
        if (col.name == 'Status') {
          if (filteredList.status && Array.isArray(filteredList.status)) {
            col.filterVals = filteredList.status;
          }
        }
      }
    }
  }
  /*column level filter*/
  applyColumnFilters() {
    //apply column filter here and assign to dataTodisplay

    // filterDict: [{Key: "Queue", Value: ["Search"]}]
    this.filterDict = [];

    this.filterOptionRequestColumn = null;
    for (const colData of this.cols) {
      const filterVals: string[] = [];
      if (colData.filterVals && colData.filterVals.length > 0) {
        for (const val of colData.filterVals) {
          if (val.checked) {
            // Handle null values - convert to string representation
            const valueToAdd = val.name != null ? val.name.toString() : " ";
            filterVals.push(valueToAdd);
          }
        }
        
        // Check if key already exists in filterDict
        const existingIndex = this.filterDict.findIndex(filter => filter.Key === colData.name);
        
        if (existingIndex !== -1) {
          // Key exists, update the Value array
          this.filterDict[existingIndex].Value = filterVals;
        } else {
          // Key doesn't exist, push new object
          this.filterDict.push({ Key: this.correctFilterColumnName(colData.name), Value: filterVals });
        }
      } else {
        // Column has no filterVals or filterVals was deleted, remove it from filterDict
        const existingIndex = this.filterDict.findIndex(filter => filter.Key === colData.name);
        if (existingIndex !== -1) {
          this.filterDict.splice(existingIndex, 1);
        }
      }
    }
    this.loadVoicemail(null);
  }

  showHideColumns() {
    const initialState = {
      headerNames: this.cols,
      localStorageName: this.localStorageName,
    };

    const config: ModalOptions = { class: 'task-menu', backdrop: 'static', initialState };

    this.modalRef = this.modalService.show(ShowHideDialogComponent, config);

    this.modalRef.content.event.subscribe((result: any) => {
      this.initializeColumnHeader();
    });
  }
  sortByColumn(colName: string) {
    this.sortColumn = colName;
    this.sortDescend = !this.sortDescend;
    
    // Update column sort indicators
    for (const col of this.cols) {
      if (col.name == colName) {
        if (this.sortDescend) {
          col.isAsc = false;
        } else {
          col.isAsc = true;
        }
      } else {
        delete col.isAsc;
      }
    }
    
    this.webStorage.setItemInLocalStorage(this.localStorageName, this.cols);
    this.loadVoicemail(null);
  }

  onRowSelect(event: any) {
    this.router.navigateByUrl(this.router.url + '/Details/' + event.data.ID);
  }

  /*
    loadVoicemails() {
      this.resetTable();
      this.pl = {
        "rowOffset": 0,
        "rowCount": 10,
        "searchValue": this.searchValue,
        "searchField": this.searchField.value,
        "filterDict": this.filterDict,
        "sortColumn": this.sortColumn,
        "sortDescend": this.sortDescend,
        "filter": { "FromDate": new Date(this.fromDate).getTime(), "ToDate": new Date(this.toDate).getTime() }
      }
      if (this.filterOptionRequestColumn != "") {
        this.pl.filterOptionRequestColumn = this.filterOptionRequestColumn;
      } else {
        delete this.pl['filterOptionRequestColumn'];
      }
      this.loading = true;
      this.managerService.GetVoicemails(this.pl).pipe(
        map((data: any) => {
          var isValid = ResponseHandler.processResponse(data, "GetVoicemails");
          if (isValid) {
            this.voiceMailList = data.Response.Data.Data;
            this.totalRecords = data.Response.Data.TotalItems;
            this.loading = false;
            this.setInnerWidthHeightParameters();
          }
          else {
  
          }
        }),
        catchError((error) => {
  
          return EMPTY;
        })
      )
        .subscribe();
    }*/

  loadVoicemail(event: TableLazyLoadEvent) {
    this.loading = true;
    if (event == null) {
      this.resetTable();
    } else {
      this.pl.rowOffset = event.first;
      this.pl.rowCount = event.rows;
    }
    this.loadVoicemailTimeout = setTimeout(
      () => {
        //load data of required page
        if (this.filterOptionRequestColumn != null) {
          this.pl.filterOptionRequestColumn = this.correctFilterColumnName(this.filterOptionRequestColumn);
        } /*else {
        this.pl['filterOptionRequestColumn'] = '';
      }*/

        console.log('loadVoicemail payload:', this.pl);
        this.managerService
          .GetVoicemails(this.pl)
          .pipe(
            map((data: any) => {
              const isValid = ResponseHandler.processResponse(data, 'GetVoicemails');
              if (isValid) {
                if (this.pl['filterOptionRequestColumn'] != null) {
                  const columnName = this.pl['filterOptionRequestColumn'];
                  this.pl['filterOptionRequestColumn'] = null;
                  // Get existing checked values for this column
                  const existingCol = this.cols.find(col => col.name === columnName);
                  const existingCheckedValues = existingCol && existingCol.filterVals ? 
                    existingCol.filterVals.filter(val => val.checked).map(val => val.name) : [];
                  
                  const filterVals = [];
                  for (const dt of data.Response.Data) {
                    // Include null and empty values in the filter options
                    if (dt != null && dt !== '' && dt.trim() !== '') {
                      const isChecked = existingCheckedValues.includes(dt);
                      filterVals.push({ name: dt, checked: isChecked });
                    } else {
                      // Add null/empty values as null
                      const isChecked = existingCheckedValues.includes(null);
                      filterVals.push({ name: null, checked: isChecked });
                    }
                  }
                  
                  for (const col of this.cols) {
                    if (col.name == columnName || col.label == columnName) {
                      col.filterVals = filterVals;
                      // Also populate the filteredList for this column so getColDetails works
                      this.populateFilteredListForColumn(columnName, filterVals);
                    }
                  }
                  this.showColumnFilterModal(columnName);
                } else {
                  this.voiceMailList = data.Response.Data.Data;
                  this.voiceMailList.forEach(element => {
                    //console.log(this.utils.formatDuration(element.Duration, 'sec', false, true, false));
                    element.Duration = this.utils.formatDuration(element.Duration, 'sec', false, true, false);
                  });
                  if (data.Response.Data.TotalFilteredItems) {
                    this.totalRecords = data.Response.Data.TotalFilteredItems;
                  } else {
                    this.totalRecords = 0;
                  }
                  this.loading = false;
                }
                //trigger change detection
                if (event && event.forceUpdate) {
                  event.forceUpdate();
                }
                this.setInnerWidthHeightParameters();
              } else {
              }
            }),
            catchError(error => {
              this.loading = false;
              console.error('Error loading voicemail:', error);
              // Trigger change detection
              if (event && event.forceUpdate) {
                event.forceUpdate();
              }
              return EMPTY;
            })
          )
          .subscribe();
      },
      Math.random() * 1000 + 250
    );
  }
  resetTable() {
    this.first = 0;
    //this.voiceMailList = [];
    //this.totalRecords = 0;

    this.pl['rowOffset'] = this.rowOffset;
    this.pl['rowCount'] = this.rowCount;
    this.pl['filterDict'] = this.filterDict;
    this.pl['filterOptionRequestColumn'] = this.filterOptionRequestColumn;
    this.pl['filter'] = {
      FromDate: new Date(this.fromDate).getTime(),
      ToDate: new Date(this.toDate).getTime(),
    };
    this.pl['sortDescend'] = this.sortDescend;
    this.pl['sortColumn'] = this.sortColumn;
    this.pl['searchValue'] = this.searchValue;
    this.pl['searchField'] = this.searchValue === '' ? '' : this.searchField.value;
  }
  setInnerWidthHeightParameters() {
    this.innerHeight = window.innerHeight * 0.07;
  }
  
  correctFilterColumnName(colName: string): any {
    let key = colName;
    if(colName == 'UserPhoneNumber'){
      key = 'User Phone';
    }else if(colName == 'InboundPhoneNumber'){
      key = 'Inbound Phone';
    }
    return key;
  }

  ngOnDestroy() {
    this.loadVoicemailTimeout && clearTimeout(this.loadVoicemailTimeout);
  }

}
